import SkillCard from './SkillCard';

export default SkillCard;
